import React, { useEffect, useState } from 'react'
import FinancialOverview from './Left/FinancialOverview'
import CompareBarGraph from '../../../components/CompareBarGraph'
import RecentTransaction from './Right/RecentTransaction'
import SpendByProject from './Right/SpendByProject'
import SalesAnalytics from './Right/SalesAnalytics'

export default function AccountDashboardAddIndex() {

  let [salePurchase, setSalePurchase] = useState(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July"])
  let [salePurchaseData, setSalePurchaseData] = useState([])
  let [investmentData, setInvestmentData] = useState([])
  let [landOwnerData, setLandOwnerData] = useState([])

  useEffect(() => {
    setSalePurchaseData([
      {
        label: 'One',
        backgroundColor: 'rgba(62, 64, 149, 1)',
        data: [],
        barThickness: 10

      }, {
        label: 'Two',
        backgroundColor: 'rgba(227, 228, 237, 1)',
        data: [],
        barThickness: 10

      },
      // {
      //   label: 'Three',
      //   backgroundColor: 'rgba(62, 64, 149, 1)',
      //   data: [0, 0, 1, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0, 0, 1, 1, 0, 1, 2, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      // }
    ])

    setInvestmentData([
      {
        label: 'Sample Data',
        data: [],
        backgroundColor: 'rgba(62, 64, 149, 1)',
        borderColor: 'rgba(62, 64, 149, 1)',
        borderWidth: 1,
        barThickness: 20
      },
    ])
    setLandOwnerData([
      {
        label: 'Sample Data',
        data: [],
        backgroundColor: 'rgba(62, 64, 149, 1)',
        borderColor: 'rgba(62, 64, 149, 1)',
        borderWidth: 1,
        barThickness: 20
      },
    ])
  }, [])

  return (
    <div className='row pb-3'>
      <div className='col col-md-8'>
        <div className='d-flex flex-column gap-3'>
          <FinancialOverview />
          <CompareBarGraph title="Sales & Purchases" datalabel={salePurchase} dataArray={salePurchaseData} yLabel="Price" xLabel="Months" />
          <CompareBarGraph title="Investment Summery" datalabel={salePurchase} dataArray={investmentData} yLabel="Price" xLabel="Months" />
          <CompareBarGraph title="Land Owner Summry" datalabel={salePurchase} dataArray={landOwnerData} yLabel="Price" xLabel="Months" />

        </div>
      </div>
      <div className='col col-md-4'>
        <div className='d-flex flex-column gap-3' >
          <RecentTransaction />
          <SpendByProject />
          <SalesAnalytics />
        </div>
      </div>
    </div>
  )
}
